<template>
  <div id="pers-tab2" name="hres32e-tab2" class="content-pers">
    <hres32e-tab2-tab1 class="animate-option animated" v-show="subPage === 1" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :allLang="allLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab1"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab1Save="postDetail2Tab1Save"
      :searchIndex="searchIndex" />

    <hres32e-tab2-tab2 class="animate-option animated" v-show="subPage === 2" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab2"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab2Save="postDetail2Tab2Save"
      :searchIndex="searchIndex" />

    <hres32e-tab2-tab3 class="animate-option animated" v-show="subPage === 3" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab3"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab3Save="postDetail2Tab3Save"
      :searchIndex="searchIndex" />

    <hres32e-tab2-tab4 class="animate-option animated" v-show="subPage === 4" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab4"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab4Save="postDetail2Tab4Save"
      :searchIndex="searchIndex" />

    <hres32e-tab2-tab5 class="animate-option animated" v-show="subPage === 5" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab5"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab5Save="postDetail2Tab5Save"
      :searchIndex="searchIndex" />

    <hres32e-tab2-tab6 class="animate-option animated" v-show="subPage === 6" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :detail="detail.tab6"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab6Save="postDetail2Tab6Save"
      :searchIndex="searchIndex" />
      
    <hres32e-tab2-tab7 class="animate-option animated" v-show="subPage === 7" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :detail2Tab7Table="detail2Tab7Table"
      :labels="labels"
      :labelsButton="labelsButton"
      :deleteDocuments="deleteDocuments"
      :dropdowns="dropdowns"
      :detail="detail.tab7"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab7Save="postDetail2Tab7Save"
      :searchIndex="searchIndex"
      :personalDataActive="personalDataActive" />

    <!-- <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div> -->
     
  </div>
</template>

<script>
import hres32eTab2Tab1 from 'components/hres32e/tab2_1'
import hres32eTab2Tab2 from 'components/hres32e/tab2_2'
import hres32eTab2Tab3 from 'components/hres32e/tab2_3'
import hres32eTab2Tab4 from 'components/hres32e/tab2_4'
import hres32eTab2Tab5 from 'components/hres32e/tab2_5'
import hres32eTab2Tab6 from 'components/hres32e/tab2_6'
import hres32eTab2Tab7 from 'components/hres32e/tab2_7'

export default {
  name: 'hres32e-tab2',
  props: [ 'nowLang',
    'allLang',
    'labels',
    'dropdowns',
    'detail',
    'pcDisp',
    'togglePage',
    'indexSelected',
    'labelsButton',
    'subPage',
    'deleteDocuments',
    'detail2Tab7Table',
    'postDetail2Tab1Save',
    'postDetail2Tab2Save',
    'postDetail2Tab3Save',
    'postDetail2Tab4Save',
    'postDetail2Tab5Save',
    'postDetail2Tab6Save',
    'postDetail2Tab7Save',
    'searchIndex',
    'personalDataActive',
    'validateStaappr'
  ],
  components: {
    hres32eTab2Tab1,
    hres32eTab2Tab2,
    hres32eTab2Tab3,
    hres32eTab2Tab4,
    hres32eTab2Tab5,
    hres32eTab2Tab6,
    hres32eTab2Tab7
  }
}
</script>


// WEBPACK FOOTER //
// tab2.vue?eb938ac4